<template>
  <a-modal
    wrap-class-name="report-confirm-modal-wrapper"
    width="520px"
    :mask-closable="false"
    :visible="visible"
    title="温馨提示"
    cancelText="再看看"
    okText="确认通过"
    @cancel="$emit('onCancel')"
    @ok="$emit('onSubmit')"
  >
    <div class="report-confirm-note">
      <a-icon type="exclamation-circle" class="icofont" />
      <span>是否确认工作报告通过审核，确认后将不可更改审核状态？</span>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: ["visible", "btnIsLoading"],
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.report-confirm-modal-wrapper {
  .report-confirm-note {
    padding: 0 10px;
    padding-bottom: 20px;
    font-size: 16px;
  }
}
.icofont {
  color: #faad14;
  font-size: 22px;
  margin-right: 5px;
  float: left;
}
</style>
